import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Card, Tag, Typography, Skeleton } from 'antd'
import { CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons'
import { OVERRIDE_TYPE_CONFIG } from '../constants/Breadcrumbs'
import { INITIAL_SUMMARY_COUNTS, SUMMARY_PROPS_SHAPE } from '../constants/OverrideTypes'
import '../styles/OverrideSummary.scss'

const { Title, Text } = Typography

const renderTypeStats = (loading, stats) => {
  return Object.entries(OVERRIDE_TYPE_CONFIG).map(([key, config]) => {
    const Icon = config.icon
    const value = stats?.byType?.[key] || 0

    return (
      <div className="type-stat" key={key}>
        {loading ? (
          <Skeleton.Button active size="small" style={{ width: 120 }} />
        ) : (
          <>
            <div className="stat-icon">
              <Icon />
            </div>
            <div className="stat-content">
              <Text>{config.title}</Text>
              <Text strong>{value}</Text>
            </div>
          </>
        )}
      </div>
    )
  })
}

const OverrideSummary = ({ overrides, loading }) => {
  const stats = {
    active: 0,
    inactive: 0,
    byType: INITIAL_SUMMARY_COUNTS,
  }

  // Calculate statistics
  Object.entries(overrides).forEach(([type, items]) => {
    const activeItems = items.filter((item) => item.status === 'active')
    stats.byType[type] = activeItems.length
    stats.active += activeItems.length
    stats.inactive += items.length - activeItems.length
  })

  return (
    <div className="override-summary">
      <Card className="summary-card">
        <div className="summary-content">
          <div className="summary-header">
            <div className="title-section">
              <Title level={2}>Fee Management</Title>
              {loading ? (
                <Skeleton.Input active size="small" style={{ width: 300 }} />
              ) : (
                <Text className="description">
                  Manage your fee and due date overrides for specific vendors and/or locations
                </Text>
              )}
            </div>
            <Text className="total-overrides">{stats.active} Active Overrides</Text>
          </div>
          <div className="summary-details">
            <div className="status-stats">
              <Tag icon={<CheckCircleOutlined />} color="success" className="status-tag">
                {stats.active} Active
              </Tag>
              <Tag icon={<ClockCircleOutlined />} className="status-tag">
                {stats.inactive} Inactive
              </Tag>
            </div>
            <div className="type-stats">{renderTypeStats(loading, stats)}</div>
          </div>
        </div>
      </Card>
    </div>
  )
}

OverrideSummary.propTypes = {
  overrides: PropTypes.shape(SUMMARY_PROPS_SHAPE).isRequired,
  loading: PropTypes.bool,
}

OverrideSummary.defaultProps = {
  loading: false,
}

export default memo(OverrideSummary)
